<template>
  <div class="content">
    <full-calendar :events="monthData"
                   class="test-fc"
                   first-day='1'
                   locale="fr"
                   @changeMonth="changeMonth()"
                   @eventClick="eventClick()"
                   @dayClick="dayClick()"
                   @moreClick="moreClick()">
    </full-calendar>
  </div>
</template>

<script>
import $ from 'jquery'
import fullCalendar from '../vender/fullCalendar'

export default {
  name: 'Calendar',
  components: {
    fullCalendar
    // 'full-calendar': require('../vender/fullCalendar')
  },
  data() {
    return {
      monthData: ''
    }
  },
  methods: {

    // 初始化日历
    initCalender() {
      $('#calendar').fullCalendar({
        header: { left: 'prev,next today', center: 'title', right: 'month,basicWeek' },
        navLinks: true, // can click day/week names to navigate views
        editable: true,
        eventLimit: true, // allow "more" link when too many events
        eventLimitText: '更多',
        events: [{ title: 'All Day Event', start: '2018-11-01', color: '#06BB87' }]
      })
    },

    // 选择月份
    changeMonth(start, end, current) {
      console.log('changeMonth')
      console.log('changeMonth', start.format(), end.format(), current.format())
    },
    // 点击事件
    eventClick(event, jsEvent, pos) {
      console.log('eventClick')
      console.log('eventClick', event, jsEvent, pos)
    },
    // 点击当天
    dayClick(day, jsEvent) {
      console.log('dayClick')
      console.log('dayClick', day, jsEvent)
    },
    // 查看更多
    moreClick(day, events, jsEvent) {
      console.log('moreCLick')
      console.log('moreCLick', day, events, jsEvent)
    }
  },
  mounted() {
    // 初始化日历
    this.initCalender()
  }
}
</script>
<style lang="scss">
.content {
  width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
}
.calendar-div {
  width: 1200px;
  margin: 0 auto;
  height: 500px;
  overflow: hidden;
  #calendar {
    width: 800px;
    height: 300px;
  }
  .el-dialog__footer {
    padding-bottom: 10px !important;
  }
}
</style>
